import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import styles from './Radio.module.scss';

const Radio = ({
  className,
  disabled,
  readOnly,
  label,
  ...restProps
}: { className: any; disabled: any; readOnly: any; label: any } & Record<
  string,
  any
>) => (
  <div
    className={cn(
      styles.radio,
      {
        [styles.radioWithLabel]: label,
        [styles.radioDisabled]: disabled,
        [styles.radioReadOnly]: readOnly,
      },
      className,
    )}
  >
    <input
      type="radio"
      className={styles.field}
      readOnly={readOnly}
      {...restProps}
    />
    <div className={styles.iconWrapper}>
      <div className={styles.icon} />
    </div>
    {label && (
      <Typography variant="body1" weight="medium" className={styles.label}>
        {label}
      </Typography>
    )}
  </div>
);

export default React.memo(Radio) as any;
